import React from 'react';
import classNames from 'classnames';
import SignUpForm from '../../forms/SignUpForm';
import LoginModal from '../LoginModal';
import '../login.scss';
import './SignUp.scss';

class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showingErrors: false,
      errors: {
        hasError: false,
        code: '',
        message: '',
        all: {},
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.auth.isLoading === true && nextProps.auth.isLoading === false) {
      // When login fails or user is trying to hack/test out to date OAuth Code in query string:
      if (nextProps.auth.errors.hasError) {
        this.setState({
          showingErrors: true,
          errors: nextProps.auth.errors,
        });
      } else {
        // Redirecting user to Complete Registration
        localStorage.setItem('showWelcome', 'true');
        if(nextProps.auth.back){
          window.location.href = nextProps.auth.back+"&rel=1";
          return;
        }else {
          this.props.router.replace('/complete-registration');
        }
      }
    }
  }

  onSubmit = (userInfo) => {
    let userInfo2;
    if (localStorage.getItem('referredSignUp')) {
      userInfo2 = {
        ...userInfo,
        referredSignUp: localStorage.getItem('referredSignUp'),
      };
    } else {
      userInfo2 = {
        ...userInfo,
      };
    }
    this.props.signUp(userInfo2);
  }

  dismissErrors = () => {
    this.setState({
      showingErrors: false,
      errors: {
        hasError: false,
        code: '',
        message: '',
        all: {},
      },
    });
  }

  render() {
    const { showingErrors, errors } = this.state;
    const { back,rel } = this.props.params;
    return (
      <section className="SignUp LogIn">
        <LoginModal className="SignUp" back={back} rel={rel}>
          <SignUpForm auth={this.props.auth} onSubmit={this.onSubmit.bind(this)} back={back}/>
          <section className={classNames('errors-container', { active: showingErrors })}>
            <div className="error-message">
              {errors.message}
            </div>
            <button className="error-dismiss" type="button" onClick={this.dismissErrors.bind(this)} />
          </section>
        </LoginModal>
      </section>
    );
  }
}

export default SignUp;
